// 登录组件
<template>
  <div class="login-box">
    <van-field
      class="input-item"
      left-icon="manager"
      v-model.trim="name"
      clearable
      placeholder="支持手机号码、用户名"
    ></van-field>
    <van-field
      class="input-item"
      :type="isShowPW?'password':''"
      left-icon="lock"
      :right-icon="isShowPW?'closed-eye':'eye-o'"
      @click-right-icon="isShowPW = !isShowPW"
      v-model.trim="password"
      clearable
      placeholder="密码"
    ></van-field>
    <van-button class="loginBtn" type="primary" size="large" @click="login">马上登录</van-button>
    <div class="btn-list">
      <span @click="go('getPassword')">忘记密码?</span>
      <!-- <span>意见反馈</span> -->
    </div>
  </div>
</template>

<script>
import { Field, Button, Toast } from "vant";
import { getUser } from "@/api/dictionary";
import { getDivisionData,getCommonDictionary } from "@/api/login";
import { mapActions, mapMutations } from "vuex";
import { setSessionStore } from "@/utils/sessionStorage";

export default {
  data() {
    return {
      name: "",
      password: "",
      isShowPW: true,
      screenHeightNoChange:true,
    };
  },
  components: {
    [Field.name]: Field,
    [Button.name]: Button
  },
  methods: {
    ...mapActions(["securityCheck"]),
    ...mapMutations(["setMemberInfo","setTitleList","setAddrList"]),
    go(type) {
      this.$router.push({ name: type});
    },
    getUserInfo() {
      return new Promise(resolve => {
        getUser().then(res => {
          if (res.success) {
            this.setMemberInfo(res.result);
            window.sessionStorage.setItem("userInfo",JSON.stringify(res.result))
            setSessionStore("memberId", res.result.id);
            resolve();
          } else {
            Toast("用户信息获取失败");
          }
        });
      });
    },
    submit() {
      var params = {
        username: this.name,
        password: this.password,
        grant_type: "password",
        scope: "server",
        client_id: "mms_meeting",
        client_secret: 123456
      };

      this.securityCheck(params)
        .then(res => {
          this.getUserInfo()
            .then(res => {
              this.$router.push({ name: 'MemberCenter' });
              // if (res.success) {
              //   // this.$router.push({ name: "userInfo" });
              //
              // }
            })
            .catch(() => {
              Toast("用户信息获取失败");
            });
        })
        .catch(res => {
          Toast("登录失败");
        });
    },
    login() {
      if (!this.name) {
        Toast("用户名不能为空");
        return;
      } else if (!this.password) {
        Toast("密码不能为空");
        return;
      }
      
      this.submit();
    }
  },
  mounted() {

    getCommonDictionary("TITLE")
          .then(res =>{
            this.setTitleList(res.result);
          });

    //获取地址
    getDivisionData()
          .then(res => {
          this.setAddrList(res.result);
          });
    const self = this;
    window.onresize = () =>{
      if(self.oldFullHeight){
        self.screenHeightNoChange = document.documentElement.clientHeight === self.oldFullHeight;
      }
    }


      }
};
</script>

<style lang="less">
.login-box {
  padding-top: 55px;
}
.input-item {
  padding: 0;
  padding-bottom: 12px;
  border-bottom: 1px solid #dfdfdf;

  i {
    color: #aaa;
    margin-right: 10px;
  }
  & + .input-item {
    margin-top: 30px;
  }
}
.loginBtn {
  margin-top: 40px;
   height: 48px !important; 
   line-height: 48px;
}
.btn-list {
  display: flex;
  margin-top: 40px;
  font-size: 14px;
  justify-content: space-between;
  color: #7d7d7d;
}
</style>
